// extracted by mini-css-extract-plugin
export default {"screen":"CheckOut_screen__Z2CrO"};